
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.381 5.429h4.524v1.81H15.38v-1.81zm-1.81 4.523h6.334v1.81H13.57v-1.81zm2.715 4.524h3.619v1.81h-3.62v-1.81zM0 19a7.238 7.238 0 1114.476 0h-1.81A5.429 5.429 0 001.81 19H0zm7.238-8.143c-3 0-5.428-2.43-5.428-5.428C1.81 2.429 4.239 0 7.238 0c3 0 5.429 2.43 5.429 5.429s-2.43 5.428-5.429 5.428zm0-1.81a3.618 3.618 0 100-7.238c-2 0-3.619 1.62-3.619 3.62s1.62 3.619 3.62 3.619z","fill":"#495567"}})])
          )
        }
      }
    